export const breakpoints = {
  mediumDesktop: 1700,
  smallDesktop: 1340,
  tabletLandscape: 1200,
  largeMobile: 700,
  smallMobile: 550
};
